import cartFragment from '../fragments/cart'

const query = `query ($cartId : ID!) {
  cart(id:$cartId) ${cartFragment}
}`

export default query
